














/** @format */

import { Component, Mixins, Watch } from 'vue-property-decorator';
import TableMixin from '@root/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
// import moment from 'moment'
import { CHANNEL_LIST_CREATE, CHANNEL_LIST } from '../router-names';
// import { debounce } from 'lodash'
import * as _ from 'lodash';

import Utils from '@root/utils/common';
import AddEditChannelList from './components/add-edit-channel-list.vue';
import GoBackWithCloseTabMixin from '@root/common/mixins/go-back-with-close-tab';
// axios请求
import { deleteChannelList } from '@/api/parking-lot-management/index';

@Component({
  components: { AddEditChannelList }
})
// @Component
export default class ChannelListCreate extends Mixins(TableMixin, TableWidthMixin, GoBackWithCloseTabMixin) {
  headTitle = '添加通道';
  path = '/smart-parking/parking-lot-management/channel-list';
  // 面包屑数据
  get breadcrumbNav() {
    return [
      {
        label: '通道信息',
        location: {
          name: CHANNEL_LIST
        }
      },
      {
        label: this.headTitle
      }
    ];
  }

  // // 返回
  // goBack() {
  //   this.$router.replace({
  //     name: CHANNEL_LIST,
  //   })
  // }
}
